module.exports = __webpack_public_path__ + "static/media/Stockholm_Sweden_6.1019d390.jpg";